import type { VoucherListByHotelId_TopPageQuery } from "@/lib/gql/__generated__/graphql";

import { useVoucherTopQuery } from "../../repository";
import { useVoucherListUpdate } from "../../repository/mutation";
import { useVoucherDelete } from "../../repository/mutation/use-voucher-delete/use-voucher-delete";
import { useNavigateToVoucherPage } from "../use-navigate/use-navigate";

type Props = {
	hotelID: string;
	data: VoucherListByHotelId_TopPageQuery | undefined;
};

export const useInitialize = ({ hotelID, data }: Props) => {
	return {
		...useVoucherTopQuery({ data }), //
		...useNavigateToVoucherPage({ hotelID }),
		...useVoucherDelete(),
		...useVoucherListUpdate(),
	};
};
